import { FC } from 'react'
import { motion } from 'framer-motion'
import { FaBullseye, FaChildReaching, FaFeather, FaFire } from 'react-icons/fa6'

interface Service {
  icon: React.ReactNode
  title: string
  description: string
}

const services: Service[] = [
  {
    icon: <FaBullseye className="text-3xl" />,
    title: 'Cellulite Reduction',
    description: 'Advanced technology to smooth skin and reduce the appearance of cellulite.',
  },
  {
    icon: <FaChildReaching className="text-3xl" />,
    title: 'Contour Shaping',
    description: 'Sculpt your body and define your curves with personalized shaping programs.',
  },
  {
    icon: <FaFeather className="text-3xl" />,
    title: 'Skin Tightening',
    description: 'Restore elasticity and firmness to your skin for a youthful, rejuvenated look.',
  },
  {
    icon: <FaFire className="text-3xl" />,
    title: 'Metabolic Boost',
    description: 'Kickstart your metabolism and support healthy weight management.',
  },
]

const Services: FC = () => {
  return (
    <section id="services" className="py-20 lg:py-32 bg-off-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="section-tag">What We Do</span>
          <h2 className="section-heading">Our Services</h2>
        </motion.div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-transparent hover:border-primary/20 group"
            >
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center text-primary mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                {service.icon}
              </div>
              
              <h3 className="text-xl font-bold text-text-dark mb-3">
                {service.title}
              </h3>
              
              <p className="text-text-gray text-sm leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
